import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { LoginMailComponent } from './auth-shared/login-mail/login-mail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthSharedModule } from './auth-shared/auth-shared.module';
import { RegisterComponent } from './register/register.component';
import { RegisterDialogMailViewComponent } from './register-dialog-mail-view/register-dialog-mail-view.component';
import { AuthenticateComponent } from './authenticate/authenticate.component';
import { EscoComponent } from './esco/esco.component';
import { SuccessComponent } from './success/success.component';
import { AnonymousComponent } from './anonymous/anonymous.component';
import { AuthDetailsComponent } from './auth-details/auth-details.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordConfermaComponent } from './reset-password-conferma/reset-password-conferma.component';
import { MyCustomMaterialModule } from 'san-common';


@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MyCustomMaterialModule,AuthSharedModule


  ],

  declarations: [RegisterComponent,
    RegisterDialogMailViewComponent,
    AuthenticateComponent,
    AuthComponent,AuthDetailsComponent,
    EscoComponent,SuccessComponent,
    AnonymousComponent,
    ResetPasswordComponent,
    ResetPasswordConfermaComponent

    ],
  exports: [
    AuthComponent],
    entryComponents:[RegisterComponent,
      RegisterDialogMailViewComponent,
      LoginMailComponent],
  providers : []
})
export class AuthModule { }
